/* eslint-disable react/jsx-no-useless-fragment */
import { isNotEmpty } from "../../utils";

const defaultStyle = { background: "inherit" };
const highlightColor = "inherit";

type OwnProps = {
  string?: string;
  match?: $TSFixMe;
  path?: string;
};

const defaultProps: Partial<OwnProps> = {
  string: "",
  match: {},
  path: "",
};

type Props = OwnProps & typeof defaultProps;

export function Highlight(props: Props) {
  const { string, match, path } = props;
  const chars = string?.split("");

  if (match && path === match?.key && chars && isNotEmpty(chars)) {
    return chars.map((char, index) => {
      const style = { ...defaultStyle };
      let classes = `character character-${index}`;

      // eslint-disable-next-line no-unused-expressions
      match?.indices?.forEach((pair: $TSFixMe) => {
        if (index >= pair[0] && index <= pair[1]) {
          style.background = highlightColor;
          classes += " highlighted";
        }
      });

      // Only use the index if items have no stable ID
      return (
        // eslint-disable-next-line react/no-array-index-key
        <span className={classes} style={style} key={index}>
          {char}
        </span>
      );
    });
  }
  return <>{string}</>;
}

Highlight.defaultProps = defaultProps;

export default Highlight;
